import { render, staticRenderFns } from "./DateReview.vue?vue&type=template&id=254e07ca"
import script from "./DateReview.vue?vue&type=script&lang=js"
export * from "./DateReview.vue?vue&type=script&lang=js"
import style0 from "./DateReview.vue?vue&type=style&index=0&id=254e07ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports